module.exports = __webpack_public_path__ + "static/tracker-page-8ab2c0302afac9580ff7a915b1e6a8ea.png";